import { Tag as AntTag } from 'antd'
import { TagProps } from 'antd/lib/tag'
import * as React from 'react'

interface Props extends TagProps {
  text: string | React.ReactNode
  color?: string
  type?: 'info' | 'default'
  dataTestId?: string
}

const KTag: React.FC<Props> = ({
  text = '-',
  color = '',
  type = 'default',
  className,
  dataTestId,
  ...others
}) => {
  return (
    <AntTag
      color={type === 'info' ? '#f0f2f5' : color}
      className={type === 'info' ? 'px-2 py-1' : className}
      data-testid={dataTestId}
      {...others}>
      <Choose>
        <When condition={type === 'info'}>
          <span className="p-1 text-black">{text}</span>
        </When>
        <Otherwise>{text}</Otherwise>
      </Choose>
    </AntTag>
  )
}

export default KTag
